<script setup lang="ts">
import { RouterView } from "vue-router";
import AppHeader from "@/components/AppHeader.vue";
import AppNotifications from "@/components/AppNotifications.vue";
import { useAuthStore } from "@/stores/auth";

const auth = useAuthStore();
</script>

<template>
  <div class="app-shell">
    <a class="skip-link" href="#main-content">Skip to content</a>
    <AppHeader />

    <div v-if="auth.errorMessage" class="global-notice" role="status">
      {{ auth.errorMessage }} You can still browse the public catalog.
    </div>

    <AppNotifications :class="{ 'notification-region-with-notice': auth.errorMessage }" />

    <main id="main-content">
      <RouterView />
    </main>

    <footer class="site-footer">
      <div class="content-width footer-inner">
        <div>
          <span class="brand-name">Washbox</span>
          <p>Reliable property care, built around real work.</p>
        </div>
        <div class="footer-meta">
          <nav class="footer-links" aria-label="Legal information">
            <a href="/legal/terms-draft-property-sms-2026-10-17-en-us.html">Draft Terms</a>
            <a href="/legal/privacy-draft-property-sms-2026-10-17-en-us.html">Draft Privacy</a>
          </nav>
          <p>Public production client · Secure sign-in by Keycloak</p>
        </div>
      </div>
    </footer>
  </div>
</template>
